/* Golf-holdgenerator – vanilla JS, ingen dependencies */
(function () {
  'use strict';

  var STORAGE_PREFIX = 'gg-holdgen-';
  var MIN_ROWS = 4;
  var HCP_MIN = -10;
  var HCP_MAX = 54;

  /* ---------- Hjælpere ---------- */

  function parseHcp(raw) {
    var s = String(raw == null ? '' : raw).trim().replace(',', '.').replace(/\s+/g, '');
    if (!/^[+-]?\d+(\.\d+)?$/.test(s)) return null;

    // I golf skrives et handicap bedre end scratch med plus, fx +2.
    // Internt gemmes det som -2, så beregninger og sortering fungerer naturligt.
    var isPlusHandicap = s.charAt(0) === '+';
    var n = parseFloat(s);
    if (isPlusHandicap) n = -Math.abs(n);

    if (!isFinite(n) || n < HCP_MIN || n > HCP_MAX) return null;
    return Math.round(n * 10) / 10;
  }

  function formatHcp(n) {
    var rounded = Math.round(n * 10) / 10;
    if (Math.abs(rounded) < 0.05) rounded = 0;

    var formatted = Math.abs(rounded).toFixed(1).replace('.', ',');
    return rounded < 0 ? '+' + formatted : formatted;
  }

  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function teamTotal(team) {
    return team.reduce(function (sum, p) { return sum + p.hcp; }, 0);
  }

  function teamAverage(team) {
    return team.length ? teamTotal(team) / team.length : 0;
  }

  function averageSpreadOf(teams) {
    var averages = teams.map(teamAverage);
    return Math.max.apply(null, averages) - Math.min.apply(null, averages);
  }

  function balanceScore(teams) {
    var playerCount = 0;
    var totalHcp = 0;

    teams.forEach(function (team) {
      playerCount += team.length;
      totalHcp += teamTotal(team);
    });

    var overallAverage = playerCount ? totalHcp / playerCount : 0;
    var squaredDeviation = teams.reduce(function (sum, team) {
      var diff = teamAverage(team) - overallAverage;
      return sum + (diff * diff);
    }, 0);

    // Forskel mellem holdgennemsnit er vigtigst.
    // Afvigelsen bruges kun til at vælge den bedste løsning ved næsten samme spread.
    return (averageSpreadOf(teams) * 1000) + squaredDeviation;
  }

  /* ---------- Fordelingsalgoritmer ---------- */

  function splitRandom(players, count) {
    var teams = [];
    for (var i = 0; i < count; i++) teams.push([]);
    shuffle(players).forEach(function (p, idx) {
      teams[idx % count].push(p);
    });
    return teams;
  }

  function splitMixed(players, count) {
    // Serpentinefordeling: 1..n, n..1 – blander høje og lave handicap
    var sorted = shuffle(players).sort(function (a, b) { return b.hcp - a.hcp; });
    var teams = [];
    for (var i = 0; i < count; i++) teams.push([]);
    var dir = 1, idx = 0;
    sorted.forEach(function (p) {
      teams[idx].push(p);
      if (dir === 1 && idx === count - 1) { dir = -1; }
      else if (dir === -1 && idx === 0) { dir = 1; }
      else { idx += dir; }
    });
    return teams;
  }

  function splitBalanced(players, count) {
    // Målet er ens gennemsnitligt handicap pr. hold.
    // Det er mere retvisende end holdtotaler, når antallet af spillere ikke går op.
    var sorted = shuffle(players).sort(function (a, b) { return b.hcp - a.hcp; });

    // Holdstørrelser må højst variere med én spiller.
    var base = Math.floor(sorted.length / count);
    var extra = sorted.length % count;
    var caps = [];
    var teams = [];
    for (var i = 0; i < count; i++) {
      caps.push(base + (i < extra ? 1 : 0));
      teams.push([]);
    }

    // Fordel de højeste handicap først. Belastningen normaliseres efter holdets
    // endelige størrelse, så et hold med en ekstra spiller ikke straffes.
    sorted.forEach(function (p) {
      var best = -1;
      var bestNormalizedLoad = Infinity;
      var bestSize = Infinity;

      for (var t = 0; t < count; t++) {
        if (teams[t].length >= caps[t]) continue;

        var normalizedLoad = teamTotal(teams[t]) / caps[t];
        if (
          normalizedLoad < bestNormalizedLoad - 0.0001 ||
          (
            Math.abs(normalizedLoad - bestNormalizedLoad) <= 0.0001 &&
            teams[t].length < bestSize
          )
        ) {
          best = t;
          bestNormalizedLoad = normalizedLoad;
          bestSize = teams[t].length;
        }
      }

      teams[best].push(p);
    });

    function improveCandidate(candidate) {
      var improved = true;
      var guard = 0;

      while (improved && guard < 300) {
        improved = false;
        guard++;
        var currentScore = balanceScore(candidate);

        for (var a = 0; a < count && !improved; a++) {
          for (var b = a + 1; b < count && !improved; b++) {
            for (var x = 0; x < candidate[a].length && !improved; x++) {
              for (var y = 0; y < candidate[b].length && !improved; y++) {
                var pa = candidate[a][x];
                var pb = candidate[b][y];

                candidate[a][x] = pb;
                candidate[b][y] = pa;

                if (balanceScore(candidate) + 0.0001 < currentScore) {
                  improved = true;
                } else {
                  candidate[a][x] = pa;
                  candidate[b][y] = pb;
                }
              }
            }
          }
        }
      }

      return candidate;
    }

    var bestTeams = improveCandidate(teams);
    var bestScore = balanceScore(bestTeams);

    // Flere startfordelinger mindsker risikoen for at ende i en lokal,
    // men ikke optimal, løsning. Antallet skaleres ned ved store spillerfelter.
    var attempts = Math.max(12, Math.min(60, Math.floor(600 / players.length)));

    for (var attempt = 0; attempt < attempts; attempt++) {
      var candidate = improveCandidate(splitRandom(players, count));
      var candidateScore = balanceScore(candidate);

      if (candidateScore + 0.0001 < bestScore) {
        bestTeams = candidate;
        bestScore = candidateScore;
      }
    }

    return bestTeams;
  }

  /* ---------- Instans ---------- */

  function initInstance(root) {
    if (root.dataset.ggReady === 'true') return;
    root.dataset.ggReady = 'true';

    var sectionId = root.getAttribute('data-section-id') || 'default';
    var storageKey = STORAGE_PREFIX + sectionId;

    var form = root.querySelector('[data-gg-form]');
    var rowsWrap = root.querySelector('[data-gg-players]');
    var rowTemplate = root.querySelector('[data-gg-row-template]');
    var addBtn = root.querySelector('[data-gg-add]');
    var teamCountSel = root.querySelector('[data-gg-teamcount]');
    var methodSel = root.querySelector('[data-gg-method]');
    var errorsBox = root.querySelector('[data-gg-errors]');
    var results = root.querySelector('[data-gg-results]');
    var teamsWrap = root.querySelector('[data-gg-teams]');
    var spreadEl = root.querySelector('[data-gg-spread]');
    var feedbackEl = root.querySelector('[data-gg-feedback]');
    var printDateEl = root.querySelector('[data-gg-print-date]');

    if (!form || !rowsWrap || !rowTemplate) return;

    var lastTeams = null;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* -- Rækker -- */

    function addRow(name, hcp, focus) {
      var node = rowTemplate.content.firstElementChild.cloneNode(true);
      var nameInput = node.querySelector('[data-gg-name]');
      var hcpInput = node.querySelector('[data-gg-hcp]');

      nameInput.value = name || '';
      hcpInput.value = hcp || '';

      node.querySelector('[data-gg-remove]').addEventListener('click', function () {
        node.remove();
        if (!rowsWrap.querySelector('[data-gg-row]')) addRow('', '', true);
        saveState();
      });

      hcpInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          addRow('', '', true);
        }
      });

      nameInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          hcpInput.focus();
        }
      });

      rowsWrap.appendChild(node);
      if (focus) nameInput.focus();
      return node;
    }

    /* -- localStorage -- */

    function saveState() {
      try {
        var players = [];
        rowsWrap.querySelectorAll('[data-gg-row]').forEach(function (row) {
          players.push({
            name: row.querySelector('[data-gg-name]').value,
            hcp: row.querySelector('[data-gg-hcp]').value
          });
        });
        window.localStorage.setItem(storageKey, JSON.stringify({
          players: players,
          teamCount: teamCountSel ? teamCountSel.value : '2',
          method: methodSel ? methodSel.value : 'balanced'
        }));
      } catch (e) { /* privat browsing m.m. – ignorér */ }
    }

    function restoreState() {
      var data = null;
      try {
        data = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
      } catch (e) { data = null; }

      if (data && Array.isArray(data.players) && data.players.length) {
        data.players.forEach(function (p) {
          addRow(String(p.name || ''), String(p.hcp || ''), false);
        });
        if (teamCountSel && data.teamCount) teamCountSel.value = data.teamCount;
        if (methodSel && data.method) methodSel.value = data.method;
      }
      while (rowsWrap.querySelectorAll('[data-gg-row]').length < MIN_ROWS) {
        addRow('', '', false);
      }
    }

    /* -- Fejl -- */

    function clearErrors() {
      errorsBox.textContent = '';
      root.querySelectorAll('.gg-holdgen__input--error').forEach(function (el) {
        el.classList.remove('gg-holdgen__input--error');
      });
    }

    function showErrors(errors) {
      clearErrors();
      var ul = document.createElement('ul');
      errors.forEach(function (err) {
        var li = document.createElement('li');
        li.textContent = err.message;
        ul.appendChild(li);
        if (err.field) err.field.classList.add('gg-holdgen__input--error');
      });
      errorsBox.appendChild(ul);
      if (errors[0] && errors[0].field) errors[0].field.focus();
    }

    /* -- Indsamling og validering -- */

    function collectPlayers() {
      var players = [];
      var errors = [];

      rowsWrap.querySelectorAll('[data-gg-row]').forEach(function (row) {
        var nameInput = row.querySelector('[data-gg-name]');
        var hcpInput = row.querySelector('[data-gg-hcp]');
        var name = nameInput.value.trim();
        var hcpRaw = hcpInput.value.trim();

        if (name === '' && hcpRaw === '') return; // helt tom række ignoreres

        if (name === '') {
          errors.push({ message: 'En spiller mangler navn.', field: nameInput });
          return;
        }
        var hcp = parseHcp(hcpRaw);
        if (hcp === null) {
          errors.push({
            message: 'Handicap for "' + name + '" er ugyldigt. Brug fx 18,4 eller +2 for et plus-handicap. Gyldigt interval er +10 til 54.',
            field: hcpInput
          });
          return;
        }
        players.push({ name: name, hcp: hcp });
      });

      return { players: players, errors: errors };
    }

    /* -- Resultatvisning -- */

    function renderTeams(teams) {
      teamsWrap.textContent = '';

      teams.forEach(function (team, i) {
        var card = document.createElement('article');
        card.className = 'gg-holdgen__team';

        var title = document.createElement('h4');
        title.className = 'gg-holdgen__team-name';
        title.textContent = 'Hold ' + (i + 1);
        card.appendChild(title);

        var list = document.createElement('ul');
        list.className = 'gg-holdgen__team-list';
        team.forEach(function (p) {
          var li = document.createElement('li');
          var nameSpan = document.createElement('span');
          nameSpan.textContent = p.name;
          var hcpSpan = document.createElement('span');
          hcpSpan.className = 'gg-holdgen__team-hcp';
          hcpSpan.textContent = 'HCP ' + formatHcp(p.hcp);
          li.appendChild(nameSpan);
          li.appendChild(hcpSpan);
          list.appendChild(li);
        });
        card.appendChild(list);

        var meta = document.createElement('div');
        meta.className = 'gg-holdgen__team-meta';
        var total = teamTotal(team);
        var pTotal = document.createElement('p');
        pTotal.textContent = 'Samlet handicap: ' + formatHcp(total);
        var pAvg = document.createElement('p');
        pAvg.textContent = 'Gennemsnit: ' + formatHcp(total / team.length);
        meta.appendChild(pTotal);
        meta.appendChild(pAvg);
        card.appendChild(meta);

        teamsWrap.appendChild(card);
      });

      var sizes = teams.map(function (team) { return team.length; });
      var sameSize = sizes.every(function (size) { return size === sizes[0]; });
      spreadEl.textContent =
        'Forskel mellem højeste og laveste holdgennemsnit: ' +
        formatHcp(averageSpreadOf(teams)) +
        (sameSize ? '' : ' (gennemsnit bruges, fordi holdene har forskellig størrelse)');
      results.hidden = false;

      if (!reducedMotion) {
        results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    /* -- Generér -- */

    function generate() {
      clearErrors();
      feedbackEl.textContent = '';

      var collected = collectPlayers();
      var errors = collected.errors;
      var players = collected.players;
      var teamCount = parseInt(teamCountSel.value, 10);

      if (errors.length === 0) {
        if (players.length < 2) {
          errors.push({ message: 'Tilføj mindst 2 spillere for at generere hold.', field: rowsWrap.querySelector('[data-gg-name]') });
        } else if (players.length < teamCount) {
          errors.push({ message: 'Du har ' + players.length + ' spillere, men har valgt ' + teamCount + ' hold. Vælg færre hold eller tilføj flere spillere.', field: null });
          teamCountSel.focus();
        }
      }

      if (errors.length) {
        showErrors(errors);
        return;
      }

      var method = methodSel.value;
      var teams;
      if (method === 'random') teams = splitRandom(players, teamCount);
      else if (method === 'mixed') teams = splitMixed(players, teamCount);
      else teams = splitBalanced(players, teamCount);

      lastTeams = teams;
      saveState();
      renderTeams(teams);
    }

    /* -- Kopiér -- */

    function buildShareText() {
      if (!lastTeams) return '';
      var lines = [];
      lastTeams.forEach(function (team, i) {
        lines.push('Hold ' + (i + 1));
        team.forEach(function (p) {
          lines.push(p.name + ' \u2013 HCP ' + formatHcp(p.hcp));
        });
        var total = teamTotal(team);
        lines.push('Samlet handicap: ' + formatHcp(total));
        lines.push('Gennemsnit: ' + formatHcp(total / team.length));
        lines.push('');
      });
      lines.push('Lavet med golf-holdgeneratoren p\u00e5 golfgodter93.shop');
      return lines.join('\n');
    }

    function copyResult() {
      var text = buildShareText();
      if (!text) return;

      function done(ok) {
        feedbackEl.textContent = ok
          ? 'Resultatet er kopieret \u2013 klar til Messenger, Facebook eller e-mail.'
          : 'Kunne ikke kopiere automatisk. Mark\u00e9r teksten og kopi\u00e9r manuelt.';
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () { done(true); }, function () { fallbackCopy(text, done); });
      } else {
        fallbackCopy(text, done);
      }
    }

    function fallbackCopy(text, done) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      ta.remove();
      done(ok);
    }

    /* -- Print -- */

    function printResult() {
      if (!lastTeams) return;
      printDateEl.textContent = new Date().toLocaleDateString('da-DK', {
        day: 'numeric', month: 'long', year: 'numeric'
      });
      document.documentElement.classList.add('gg-holdgen-printing');
      results.classList.add('gg-holdgen__results--printing');

      var cleanup = function () {
        document.documentElement.classList.remove('gg-holdgen-printing');
        results.classList.remove('gg-holdgen__results--printing');
        window.removeEventListener('afterprint', cleanup);
      };
      window.addEventListener('afterprint', cleanup);
      window.setTimeout(function () {
        window.print();
        window.setTimeout(cleanup, 1000); // fallback hvis afterprint ikke affyres
      }, 50);
    }

    /* -- Nulstil -- */

    function resetAll() {
      rowsWrap.textContent = '';
      for (var i = 0; i < MIN_ROWS; i++) addRow('', '', false);
      teamCountSel.value = '2';
      methodSel.value = 'balanced';
      lastTeams = null;
      teamsWrap.textContent = '';
      spreadEl.textContent = '';
      feedbackEl.textContent = '';
      results.hidden = true;
      clearErrors();
      try { window.localStorage.removeItem(storageKey); } catch (e) { /* ignorér */ }
      var first = rowsWrap.querySelector('[data-gg-name]');
      if (first) first.focus();
    }

    /* -- Events -- */

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      generate();
    });

    addBtn.addEventListener('click', function () { addRow('', '', true); });
    rowsWrap.addEventListener('input', saveState);
    teamCountSel.addEventListener('change', saveState);
    methodSel.addEventListener('change', saveState);

    root.querySelector('[data-gg-regenerate]').addEventListener('click', generate);
    root.querySelector('[data-gg-copy]').addEventListener('click', copyResult);
    root.querySelector('[data-gg-print]').addEventListener('click', printResult);
    root.querySelector('[data-gg-reset]').addEventListener('click', resetAll);

    restoreState();
  }

  /* ---------- Initialisering ---------- */

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-gg-holdgen]').forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();